document.addEventListener('DOMContentLoaded', () => {
  function slideUp(el, duration = 300) {
    el.style.overflow = 'hidden';
    el.style.transitionProperty = 'height, padding, margin';
    el.style.transitionDuration = `${duration}ms`;
    el.style.height = `${el.scrollHeight}px`;
    el.offsetHeight; // force reflow
    el.style.height = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-duration');
    }, duration);
  }

  function slideDown(el, duration = 300) {
    el.style.removeProperty('display');
    let display = getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    el.offsetHeight; // force reflow
    el.style.transitionProperty = 'height, padding, margin';
    el.style.transitionDuration = `${duration}ms`;
    el.style.height = `${height}px`;
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-duration');
    }, duration);
  }

  function handleAccordionClick(listSelector, triggerSelector) {
    document.querySelectorAll(`${listSelector} > li > .answer`).forEach(el => {
      el.style.display = 'none';
    });

    document.querySelectorAll(`${listSelector} > li > ${triggerSelector}`).forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const parent = trigger.parentElement;

        if (parent.classList.contains('active')) {
          parent.classList.remove('active');
          slideUp(parent.querySelector('.answer'));
        } else {
          document.querySelectorAll(`${listSelector} > li.active`).forEach(activeLi => {
            slideUp(activeLi.querySelector('.answer'));
            activeLi.classList.remove('active');
          });
          parent.classList.add('active');
          slideDown(parent.querySelector('.answer'));
        }
      });
    });
  }

  handleAccordionClick('.accordion-list', 'h3');
  handleAccordionClick('.accordion-list', 'span');
  handleAccordionClick('.toggle-list', 'p');
  handleAccordionClick('.toggle-list', 'img');
});
